import { render } from "./ChangeMailingPayment.vue?vue&type=template&id=02fdd8a0&ts=true"
import script from "./ChangeMailingPayment.vue?vue&type=script&lang=ts"
export * from "./ChangeMailingPayment.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__